<template>
  <div class="string">
    <div class="label icon-metro"></div>
    <div class="fields mb-field">
      <div class="order-input day">
        <select
          @change="getDistanceFromMetro(getDotIndex(dot))"
          name="day"
          id="day"
          v-model="metroId"
        >
          <option v-for="metro in metroList[selectedCity.id]" :key="metro.id" :value="metro.id">
            {{ metro.name }}
          </option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import { GENERAL_STORE } from '@apps/order-form/src/store'

export default {
  name: 'MetroComponent',
  props: {
    dot: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState(GENERAL_STORE, ['metroList']),
    ...mapGetters(GENERAL_STORE, ['selectedCity', 'getDotIndex']),
    metroId: {
      get() {
        return this.dot.metroId
      },
      set(value) {
        this.updateDot({ dot: this.dot, data: { key: 'metroId', value } })
      },
    },
  },
  methods: {
    ...mapActions(GENERAL_STORE, ['getDistanceFromMetro']),
    ...mapMutations(GENERAL_STORE, ['updateDot']),
  },
}
</script>

<style scoped>
.day {
  grid-column: 1 / -1 !important;
}
</style>
